
import React from "react";
import { cn } from "@/lib/utils";
import { LeadStageType } from "@/context/LeadContext";

interface LeadStatusBadgeProps {
  status: LeadStageType;
  className?: string;
}

const LeadStatusBadge: React.FC<LeadStatusBadgeProps> = ({ status, className }) => {
  const getStatusStyles = () => {
    switch (status) {
      case "σεΕκκρεμότητα":
        return "bg-yellow-100 text-yellow-800";
      case "έκλεισεΗΔουλειά":
        return "bg-green-100 text-green-800";
      case "ήθελεΠληροφορίες":
        return "bg-blue-100 text-blue-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case "σεΕκκρεμότητα":
        return "Σε εκκρεμότητα";
      case "έκλεισεΗΔουλειά":
        return "Έκλεισε η δουλειά";
      case "ήθελεΠληροφορίες":
        return "Ήθελε πληροφορίες";
      default:
        return "Άγνωστο";
    }
  };

  return (
    <span
      className={cn(
        "px-2 py-1 rounded-full text-xs font-medium",
        getStatusStyles(),
        className
      )}
    >
      {getStatusLabel()}
    </span>
  );
};

export default LeadStatusBadge;
